export default "__VITE_ASSET__DN9YscDo__"